import {Injectable} from '@angular/core';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {AccessType} from '@app/modules/shared/data/constants';
import {GameModeModel, GameModeState} from '@app/state/game-mode.state';
import {Store} from '@ngxs/store';
import {RemoteParticipantsInfo} from '@app/models/remote-participants-info';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';

@Injectable({
  providedIn: 'root'
})
export class UsersListService {
  public remoteUsersWrapper: RemoteParticipantsInfo = new RemoteParticipantsInfo();
  public listUsers: { [key: number]: RemoteParticipantInfo [] } = {};
  public videoSectionUsers: RemoteParticipantInfo [] = [];
  private gameState: GameModeModel;
  private localUser: LocalUser;

  constructor(
    private store: Store
  ) {
    this.store.select(GameModeState).subscribe((gameState: GameModeModel) => {
      this.gameState = gameState;
    });

    this.store.select(LocalUserState.getLocalUser).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  public sortUsers(): void {
    this.listUsers = this.sortByTeam(this.remoteUsersWrapper.getAllUsersExceptTeachers());
    let videoSectionUsersByTeam: { [key: number]: RemoteParticipantInfo [] } = this.sortByTeam(this.remoteUsersWrapper.students);

    this.listUsers = this.sortListUsers(this.listUsers);
    videoSectionUsersByTeam = this.sortVideoSectionUsers(videoSectionUsersByTeam);

    let localUserTeamMembers: RemoteParticipantInfo[] = [];
    if (this.gameState.participantsTeamIndexById[this.localUser.id]) {
      const localUserTeamIndex: number = this.gameState.participantsTeamIndexById[this.localUser.id];
      localUserTeamMembers = videoSectionUsersByTeam[localUserTeamIndex] || [];
      delete videoSectionUsersByTeam[localUserTeamIndex];
    }

    const studentsMatrix: RemoteParticipantInfo[][] = Object.values(videoSectionUsersByTeam);
    this.videoSectionUsers = [];
    studentsMatrix.forEach((students: RemoteParticipantInfo[]) => {
      students.forEach((student: RemoteParticipantInfo) => {
        this.videoSectionUsers.push(student);
      });
    });
    this.videoSectionUsers = [...localUserTeamMembers, ...this.videoSectionUsers];
  }

  private sortByTeam(remoteUsers: RemoteParticipantInfo[]): { [key: number]: RemoteParticipantInfo [] } {
    const sortedByTeam: { [key: number]: RemoteParticipantInfo [] } = {};
    remoteUsers.sort((a, b) => {
      return a.displayName.localeCompare(b.displayName);
    });
    for (const remoteUser of remoteUsers) {
      let teamIndex = -1;
      /* team index can be 0, and 0 is false value */
      if (this.gameState.participantsTeamIndexById[remoteUser.id] !== undefined) {
        teamIndex = this.gameState.participantsTeamIndexById[remoteUser.id];
      }

      if (!sortedByTeam[teamIndex]) {
        sortedByTeam[teamIndex] = [];
      }
      sortedByTeam[teamIndex].push(remoteUser);
    }
    return sortedByTeam;
  }

  private sortListUsers(usersByTeam: { [key: number]: RemoteParticipantInfo [] }): { [key: number]: RemoteParticipantInfo [] } {
    for (const teamIndex of Object.keys(usersByTeam)) {
      // students who are not part of any team
      if (teamIndex === '-1') {
        usersByTeam[teamIndex].forEach(user => {
          if (user.additionalInfo.isClassParticipant) {
            user.additionalInfo.orderIndex = 1;
          } else if (user.accessType !== AccessType.OBSERVER && user.accessType !== AccessType.SUPPORT) {
            user.additionalInfo.orderIndex = 2;
          } else {
            user.additionalInfo.orderIndex = 3;
          }
        });

        usersByTeam[teamIndex].sort((a, b) => {
          if (a.additionalInfo.orderIndex === b.additionalInfo.orderIndex) {
            return 0;
          } else if (a.additionalInfo.orderIndex < b.additionalInfo.orderIndex) {
            return -1;
          } else {
            return 1;
          }
        });
      } else {
        usersByTeam[teamIndex].sort((a, b) => a.displayName.localeCompare(b.displayName));
      }
    }
    return usersByTeam;
  }

  private sortVideoSectionUsers(usersByTeam: { [key: number]: RemoteParticipantInfo [] }): { [key: number]: RemoteParticipantInfo [] } {
    usersByTeam[-1]?.sort((a, b) => {
        if (a.additionalInfo.isClassParticipant && b.additionalInfo.isClassParticipant) {
          return 0;
        }
        if (a.additionalInfo.isClassParticipant) {
          return -1;
        }
        if (b.additionalInfo.isClassParticipant) {
          return 1;
        }
    });
    return usersByTeam;
  }
}
